<template>
  <a-button type="link" size="small" @click="() => visible = true">{{ title }}</a-button>
  <a-modal :width="400" v-model:open="visible" @ok="submit">
    <a-space direction="vertical" style="width: 100%; margin-top: 30px;">
      <a-input-search v-model:value="searchKey" placeholder="搜索..." style="width: 100%;" />
      <div class="select-box">
        <a-tree :auto-expand-parent="true" v-model:selectedKeys="selectedValue" :defaultExpandAll="true"
          :tree-data="source">
          <template #title="{ title, key }">
            <span :class="{ 'exist': props.value.indexOf(key) > -1 }">
              {{ title }}
            </span>
          </template>
        </a-tree>
      </div>
    </a-space>
  </a-modal>
</template>
<script setup lang="ts">
import { getSimpleGood } from '@src/scripts/api/good'
import { getMenuTree } from '@src/scripts/huasky'
import { watch } from 'vue'
import { computed, ref } from 'vue'
import { onMounted, reactive } from 'vue'


const props = withDefaults(defineProps<{
  mode?: 'single' | 'multi',
  value?: string[]
}>(), {
  mode: 'single',
  value: () => []
})
const emits = defineEmits(['update:value'])



const searchKey = ref('')
const menus = ref<SimpleGood[]>([])
const selectedMenu = computed(() => menus.value.first(a => a.id === props.value.first()))
const visible = ref(false)
const tree = ref<TreeData[]>([])
const selectedValue = ref<string[]>([])

// const selectedValue = computed(() => {
//   return [props.value].flatMap(a => a)
// })
/**
 * 监听显示变化，变化时，赋值选项值
 */
watch(() => visible, () => {
  selectedValue.value = props.value
  searchKey.value = ''
})

const title = computed(() => {
  if (!props.value || props.value.length === 0) return '选择商品'
  const ids = [props.value].flatMap(a => a)
  let content = ''
  ids.forEach(id => {
    menus.value.forEach(menu => {
      if (menu.id !== id) return
      content += menu.name + '+ '
    })
  })
  if (content) content = content.slice(0, content.length - 2)
  return content ?? '选择商品'
})

const source = computed(() => {
  if (!searchKey.value?.trim()) return tree.value
  const obj = $util.clone(tree.value)
  obj.forEach(node => {
    if (!node.children || node.children.length === 0) return
    node.children = node.children.filter(a => a.title.filter(searchKey.value))
  })
  return obj
})

onMounted(async () => {
  const { data } = await getSimpleGood()
  menus.value = data
  tree.value = await getMenuTree(null, data)
})

const submit = () => {
  emits('update:value', selectedValue.value)
  visible.value = false
}

defineExpose({
  title,
  selectedMenu,
})

</script>
<style scoped lang="scss">
.exist {
  color: red;
}

.select-box {
  height: calc(100vh - 400px);
  overflow: auto;
  min-height: 400px;
}
</style>